module.exports = __webpack_public_path__ + "img/spaceship-01.921f8fe4.png";